import { duration } from '@play-co/components';
import StateObserver from 'src/StateObserver';
import { useCache } from 'src/lib/utils';

export function fetchClusterSuggestions() {
  return useCache(
    async () => {
      return StateObserver.replicant.asyncGetters.fetchClusterFriendSuggestions(
        {},
      );
    },
    `fetchClusterFriendSuggestions`,
    duration({ minutes: 10 }),
  );
}

/**
 * Remove a player from the cached cluster suggestions without refetching.
 * Used after sending a friend request to a suggested player.
 */
export function removeClusterSuggestionFromCache(playerId: string) {
  fetchClusterSuggestions().setCached((cached) => {
    if (!cached) return undefined;
    cached.data.suggestions = cached.data.suggestions.filter(
      (player) => player.id !== playerId,
    );
    return cached;
  });
}

/**
 * Synchronously drop the cached cluster suggestions so the next `get()` does a
 * genuinely fresh fetch. Unlike `invalidate()` (which marks the entry stale
 * asynchronously and may await an in-flight fetch first), `setCached` deletes
 * the cache entry immediately, guaranteeing a refetch on the next open.
 */
export function clearClusterSuggestionsCache() {
  fetchClusterSuggestions().setCached(() => undefined);
}
